import React, { useState } from 'react';
import { HistoryTableRow } from 'components/HistoryTableRow';
import { ReactComponent as MinusIcon } from 'assets/svg/minus.svg';
import { ReactComponent as PlusIcon } from 'assets/svg/plus.svg';
import styles from 'css_modules/HistoryTable.module.css';
import rowstyles from 'css_modules/HistoryTableRow.module.css';
import { formatDate } from 'helpers/tools';

function getEventName(eventId) {
  const names = {
    crt: 'Created',
    rea: 'Read',
    asg: 'Assigned',
    fil: 'Filled',
    apr: 'Approved',
    sbm: 'Submitted',
    rej: 'Rejected',
    imp: 'Imported',
    err: 'Error',
    rem: 'Removed',
    eml: 'Email',
    uns: 'Unspecified',
    crtitm: 'Items created',
    remitm: 'Items removed',
    chaut: 'User doc type changed',
  };
  return names[eventId] || eventId;
}

export const HistoryTable = ({ logs }) => {
  

  const actionEvents = ['crt', 'cha','rea', 'asg', 'fil', 'apr', 'sbm', 'rej', 'imp', 'err', 'rem', 'eml', 'uns', 'crtitm', 'remitm', 'chaut'];

  const groups = [];
  let currentGroup = null;

  logs.forEach((log) => {
    if (currentGroup && currentGroup.eventId === log.event.id) {
      currentGroup.logs.push(log);
    } else {
      if (currentGroup) groups.push(currentGroup);
      currentGroup = { eventId: log.event.id, logs: [log] };
    }
  });
  if (currentGroup) groups.push(currentGroup);

  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleGroup = (eventId, index) => {
    setExpandedGroups((prev) => {
      const key = `${eventId}-${index}`;
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };

  function getAuthor(log) {
    if (
        log.level &&
        (log.role === 'Management user' || log.role === 'Schvalovací uživatel')
    ) {
        return `${log.created_by} (${log.role} Úr. ${log.event.management_level})`;
    }
    return log.role ? `${log.created_by} (${log.role})` : log.created_by;
    }


  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th></th>
          <th>Událost</th>
          <th>Čas</th>
          <th>Autor</th>
          <th></th>
        </tr>
      </thead>
      <tbody className={styles.body}>
        {groups.map(({ eventId, logs: groupLogs }, index) => {
          const key = `${eventId}-${index}`;
          const isExpandable = groupLogs.length > 1 && actionEvents.includes(eventId);
          const isExpanded = !!expandedGroups[key];

          if (isExpandable) {
            return (
              <React.Fragment key={key}>
                <tr
                  className={`${styles.expandableRow} ${isExpanded ? styles.expanded : ''}`}
                  onClick={() => toggleGroup(eventId, index)}
                  aria-expanded={isExpanded}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') toggleGroup(eventId, index);
                  }}
                >
                  <td className={`${styles.expandableRow} ${isExpanded ? styles.expanded : ''}`}></td>
                  <td className={`${styles.expandableRowblack} ${isExpanded ? styles.expanded : ''}`}>{getEventName(groupLogs[0].event.message)} ({groupLogs.length})</td>
                  <td className={`${styles.expandableRow} ${isExpanded ? styles.expanded : ''}`}>{formatDate(groupLogs[0].created_at)}</td>
                  <td className={`${styles.expandableRow} ${isExpanded ? styles.expanded : ''}`}>{getAuthor(groupLogs[0])}</td>
                  <td className={`${styles.expandableRow} ${isExpanded ? styles.expanded : ''}`}>
                    {isExpanded ? <MinusIcon className={rowstyles.toggleDetailIcon} /> : <PlusIcon className={rowstyles.toggleDetailIcon} />}
                  </td>
                </tr>
                {isExpanded &&
                  groupLogs.map((log, i) => (
                    <HistoryTableRow
                      key={`${key}-log-${i}`}
                      log={log}
                      highlight={false}
                      inExpandedGroup={true}
                    />
                  ))}
              </React.Fragment>
            );
          } else {
            return (
              <HistoryTableRow key={key} log={groupLogs[0]} highlight={false} />
            );
          }
        })}
      </tbody>
    </table>
  );
};
